import React from "react";

const Loader = ({ showLoader, className = "" }) => {

    if (!showLoader) return;
    return <div data-testid="loader" className={`vve-common-loader ${className}`}></div>
}

export default Loader;
